<template>
  <div class="layout-wrapper">
    <img
      width="99999"
      height="99999"
      alt="Splash"
      style="
        user-select: none;
        pointer-events: none;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: var(--app-height, 100dvh);
        max-width: 100%;
        max-height: var(--app-height, 100dvh);
      "
      src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSI5OTk5OXB4IiBoZWlnaHQ9Ijk5OTk5cHgiIHZpZXdCb3g9IjAgMCA5OTk5OSA5OTk5OSIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj48ZyBzdHJva2U9Im5vbmUiIGZpbGw9Im5vbmUiIGZpbGwtb3BhY2l0eT0iMCI+PHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9Ijk5OTk5IiBoZWlnaHQ9Ijk5OTk5Ij48L3JlY3Q+IDwvZz4gPC9zdmc+"
    />

    <LayoutHeader v-if="!empty" />
    <LayoutMenu v-if="!empty" />
    <slot />
    <LayoutFooter v-if="!empty" />
  </div>
</template>

<script setup lang="ts">
  const route = useRoute()

  // Check if route meta has empty layout requested, or we can use separate layout.
  // For now, let's allow a prop or meta.
  const empty = computed(() => route.meta.empty === true)

  const head = useLocaleHead()

  onMounted(() => {
    let height = document.documentElement.clientHeight
    let width = document.documentElement.clientWidth
    let scrollWidth = window.innerWidth - document.documentElement.offsetWidth

    const resize = () => {
      height = document.documentElement.clientHeight
      width = document.documentElement.clientWidth
      scrollWidth = window.innerWidth - document.documentElement.offsetWidth

      document.documentElement.style.setProperty("--app-zoom", `1`)
      document.documentElement.style.setProperty("--app-height", `calc(${height}px / var(--app-zoom, 1))`)
      document.documentElement.style.setProperty("--app-width", `calc(${width}px / var(--app-zoom, 1))`)
      document.documentElement.style.setProperty("--app-scroll-width", `${scrollWidth}px`)
    }

    resize()
    window.addEventListener("resize", resize)

    // data-toggle functionality
    document.addEventListener("click", function (event) {
      const target = event.target as HTMLElement
      const element = target.closest("[data-toggle]")

      if (element) {
        const selector = element.getAttribute("data-toggle")
        if (selector) {
          const targetElement = document.querySelector(selector)
          if (targetElement) targetElement.classList.toggle("show")
        }
      }
    })
  })

  useHead(() => ({
    htmlAttrs: {
      lang: head.value.htmlAttrs!.lang,
      dir: head.value.htmlAttrs!.dir,
      style: "--app-zoom: 1; --app-height: 100dvh; --app-width: 100vw; --app-scroll-width: 0;"
    },
    link: [
      ...(head.value.link || []),
      { rel: "icon", type: "image/x-icon", href: "/favicon.svg" },
      { rel: "stylesheet", href: "https://api.mapbox.com/mapbox-gl-js/v3.9.3/mapbox-gl.css" },
      { rel: "stylesheet", href: "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css" }
    ],
    meta: [
      ...(head.value.meta || []),
      { name: "format-detection", content: "telephone=no" },
      { name: "viewport", content: "width=device-width, initial-scale=1.0, maximum-scale=3.0, minimum-scale=0.5" }
    ],
    script: [{ src: "https://www.google.com/recaptcha/api.js", async: true, defer: true }]
  }))
</script>
